import * as React from 'react';
import { useEffect, useState } from 'react';
import { Note as NoteIcon} from "theme/icon";
import { connect } from "react-redux";
import * as actions from "redux/actions/pendingActions";
import { Translate, I18n } from "react-redux-i18n";
import { confirmDialog } from 'utils/confirmDialog';
import alertify from 'alertifyjs';
import 'assets/css/modal.css';

// const useStyles = {
//     root: {
//         height: '100%'
//     },
//     content: {
//         alignItems: 'center',
//         display: 'flex'
//     },
//     title: {
//         fontWeight: 700
//     },
//     avatar: {
//         backgroundColor: theme.palette.success.main,
//         height: 56,
//         width: 56,
//         marginRight: "10px"
//     },
//     icon: {
//         height: 32,
//         width: 32
//     },
//     difference: {
//         marginTop: theme.spacing(2),
//         display: 'flex',
//         alignItems: 'center'
//     },
//     differenceIcon: {
//         color: theme.palette.success.dark
//     },
//     differenceValue: {
//         color: theme.palette.success.dark,
//         marginRight: theme.spacing(1)
//     }
// };

function Note(props) {

    const [open, setOpen] = React.useState(false);
    const [values, setValues] = useState({
        text: (props.item && props.item.text) || ""
    });
    const handleClickOpen = () => {
        setOpen(!open);
        setValues({
            ...values,
            text: (props.item && props.item.text) || ""
        });
    }

    const handleClose = () => {
        if (props.item && (props.item.text !== values.text)) {
            confirmDialog({
                title: I18n.t('warning'),
                message: `${I18n.t('save_change')}?`,
                onConfirm: () => {
                    props.updateItem({
                        id: props.user_id,
                        text: values.text,
                        pending_id: props.item.id,
                    }, props.token);
                    setOpen(false);
                },
                onCancel: () => setOpen(false),
                okLabel: I18n.t('save'),
                cancelLabel: I18n.t('cancel'),
                variant: 'default',
            });
        } else setOpen(false);

    }

    const handleSave = () => {
        if (values.text.length > 0) {
            props.updateItem({
                id: props.user_id,
                text: values.text,
                pending_id: props.item.id
            }, props.token);
            alertify.success("Success");
        }
        // setOpen(false);
    };

    useEffect(() => {
        props.loadItem({
            id: props.user_id,
            lang: props.lang
        }, props.token);
    }, []);

    useEffect(() => {
        if (props.item?.text !== undefined) {
            setValues((prev) => ({
                ...prev,
                text: props.item.text || '',
            }));
        }
    }, [props.item?.id, props.item?.text]);

    const onChange = (event) => {
        event.persist();
        setValues(values => ({
            ...values,
            [event.target.name]: event.target.value
        }));
    };

    const list = (anchor) => (
        <div
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
        // onClick={toggleDrawer(anchor, false)}
        // onKeyDown={toggleDrawer(anchor, false)}
        >
        </div>
    );
//sx={{ '& > :not(style)': { m: 1 } }}
    return (
        <div >
            <button
                type="button"
                className="floating-action-btn"
                aria-label={I18n.t('notes')}
                onClick={handleClickOpen}
            >
                <NoteIcon size={20} />
            </button>
            {open && (
                <div 
                className='dialog'
                // onClose={handleClose}
                key={props.key}
                // fullWidth={"true"}
                // maxWidth={"md"}
                >
                      {/* <span className="close-button">&times;</span> */}
                <div className='dialog-content' style={{"width": "80vw", "maxWidth": "800px"}}>
                <h2 className='dialog-title'> Notas Pendientes</h2>


                    <div style={{}}>
                        <textarea
                            // className="text_comment"
                            // minRows={10}
                            style={{
                                "height": "calc(100vh - 300px)",
                                "width": "100%",
                                "padding": "10px",
                                "fontFamily": "inherit",
                                "fontSize": "inherit"
                            }}
                            //maxRows={2}
                            placeholder={""}
                            //onBlur={props.onBlur}
                            //defaultValue=""
                            name="text"
                            onChange={onChange}
                            value={values.text}
                        />
                    </div>
              
                <div className='dialog-actions'>
                   
                     <button 
                        className = 'btn btn-secondary ' 
                        onClick={handleClose}
                         variant="outlined"
                    >
                        <Translate value="exit" />
                    </button>
                     <button
                        className = 'btn btn-primary ' 
                        onClick={handleSave}
                        disabled={!values.text || !values.text.trim()}
                    ><Translate value="save" />
                    </button>

                </div>
                  </div>
            </div>
            )}
        </div>
        
    );
}

function mapStateToProps(reducer) {
    // console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        item: reducer.pending.item,

        lang: reducer.i18n.locale
    };
}
const mapDispatchToProps = dispatch => ({
    loadItem: (params, token) =>
        dispatch(actions.loadItem({ params, token })),
    updateItem: (params, token) =>
        dispatch(actions.updateItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Note);
/**
 * index % 2 === 0 ? <InboxIcon /> : 
 */
